export default __webpack_public_path__ + "static/media/element-background.973a127f.jpg";